export default __webpack_public_path__ + "static/media/potato_chips.3180caad.png";